export enum LinkTemplateFieldValueType {
  ANY = 'any',
  ANY_VALUE = 'Any value', // weird type returned only in 'nameLinkTemplate'
  FIXED = 'fixed',
  SUGGESTIONS = 'suggestions',
  CHOOSE = 'choose',
  EMPTY = 'empty',
  APP_WIDE_DEFAULT = 'default', // applies only to social media tags and redirects
}

export enum LinkTemplateRedirectType {
  DEFAULT = 'default',
  DEEPVIEW = 'deepview',
  WEB_URL = 'webUrl',
  ANY = 'any',
}

export enum LinkTemplateWebOnlyLinkType {
  TRUE = 'true',
  FALSE = 'false',
  EITHER = 'either',
}

export enum LinkWebOnlyLinkType {
  TRUE = 'true',
  FALSE = 'false',
  EITHER = 'either',
}

export enum QuickLinkRedirectOverride {
  WEB_URL = 'WebUrl',
  DEEPVIEW = 'Deepview',
  DEFAULT_REDIRECT = 'DefaultRedirect',
}

export enum AdLinkFormat {
  CROSS_PLATFORM_DISPLAY = 'Cross-Platform Display',
  CROSS_PLATFORM_SEARCH = 'Cross-Platform Search',
  APP_ONLY = 'App Only',
}
